// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_screen__PR8wp {
  min-height: 100vh; }

.styles_container__2cCjI {
  min-height: calc(100vh - 4rem);
  margin-top: 4rem; }

.styles_content__I2lvQ {
  text-align: center; }

.styles_title__bte4a {
  font-size: 5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  color: #808080e6; }
  @media (max-width: 48rem) {
    .styles_title__bte4a {
      font-size: 3rem; } }

.styles_text__gS\\+-A {
  font-size: 2rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #808080e6; }
  @media (max-width: 48rem) {
    .styles_text__gS\\+-A {
      font-size: 1.5rem; } }

.styles_subtext__4OpRO {
  font-size: 1.125rem;
  margin-bottom: 2rem;
  color: #808080b8; }
  @media (max-width: 48rem) {
    .styles_subtext__4OpRO {
      font-size: 1rem; } }

.styles_button__4jc7R {
  margin-top: 1rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/screens/NotFoundPage/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,iBAAiB,EAAA;;AAGnB;EACE,8BAA8B;EAC9B,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBCDgB,EAAA;EDGhB;IANF;MAOI,eAAe,EAAA,EAElB;;AAED;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBCZgB,EAAA;EDchB;IANF;MAOI,iBAAiB,EAAA,EAEpB;;AAED;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBCvBgB,EAAA;EDyBhB;IALF;MAMI,eAAe,EAAA,EAElB;;AAED;EACE,gBAAgB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.screen {\n  min-height: 100vh;\n}\n\n.container {\n  min-height: calc(100vh - 4rem);\n  margin-top: 4rem;\n}\n\n.content {\n  text-align: center;\n}\n\n.title {\n  font-size: 5rem;\n  font-weight: bold;\n  margin-bottom: 1rem;\n  color: $grey90;\n\n  @media (max-width: 48rem) {\n    font-size: 3rem;\n  }\n}\n\n.text {\n  font-size: 2rem;\n  margin-bottom: 1rem;\n  font-weight: 600;\n  color: $grey90;\n\n  @media (max-width: 48rem) {\n    font-size: 1.5rem;\n  }\n}\n\n.subtext {\n  font-size: 1.125rem;\n  margin-bottom: 2rem;\n  color: $grey72;\n\n  @media (max-width: 48rem) {\n    font-size: 1rem;\n  }\n}\n\n.button {\n  margin-top: 1rem;\n}\n\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `styles_screen__PR8wp`,
	"container": `styles_container__2cCjI`,
	"content": `styles_content__I2lvQ`,
	"title": `styles_title__bte4a`,
	"text": `styles_text__gS+-A`,
	"subtext": `styles_subtext__4OpRO`,
	"button": `styles_button__4jc7R`
};
export default ___CSS_LOADER_EXPORT___;
